import type { Dimension } from '@dashboard/types/config'
import { getInclusionOptions } from '../logicHelpers'
import { segmentName } from '@dashboard/modules/segment/services/segmentUtilities'
import { useSegmentGroupStore } from '@dashboard/modules/segment/stores/segmentGroupStore'
import { stripHtml } from '@dashboard/services/string'
import { storeToRefs } from 'pinia'
import { useQuestionStore } from '../../stores/questionStore'
import { getQuestionName } from '../../services/questionActions'
import { getQuestionType } from '../../services/questionCatalog'

const segmentsSource = ({ ignoreSegmentGroups }: { ignoreSegmentGroups: Dimension[] }) => {
  const segmentGroupStore = useSegmentGroupStore()
  const { segmentGroups } = storeToRefs(segmentGroupStore)
  const questionStore = useQuestionStore()
  const ignoreIds = (ignoreSegmentGroups || []).map((g) => g.id)

  const eligibleGroups = segmentGroups.value.filter((group) => !ignoreIds.includes(group.id))

  return {
    types: eligibleGroups.map((group) => {
      const question = questionStore.questions.find((item) => item.dimensionId === group.id)
      return {
        label: question ? getQuestionName(question, group) : group.name,
        value: group.id,
        questionType: question ? getQuestionType(question) : undefined
      }
    }),
    inputs: [
      {
        control: 'select',
        key: 'segment-includes',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string }) => condition.$source === 'segments'
      },
      ...eligibleGroups.map((group) => ({
        control: 'multiselect',
        key: 'segment-select',
        name: 'segmentId',
        multiple: true,
        'open-on-focus': true,
        'clear-search-on-open': true,
        options: group.segments.map((segment) => ({
          label: stripHtml(segmentName(segment)),
          value: segment.id
        })),
        can: (condition: { $source: string; $type: string; operator: string }) =>
          condition.$source === 'segments' &&
          condition.$type === group.id &&
          (condition.operator || '').includes('include')
      }))
    ]
  }
}

export default segmentsSource
